
import { Component, EventEmitter, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Payment, LPGDistService } from '../../../lpg-dist.service';
import { OrganisationService } from 'src/app/organisation/organisation.service';
import { Organisation } from 'src/app/generated/services/organisations/organisation';
import  momentJ from 'moment-jalaali';
import { ActivatedRoute, Router } from '@angular/router';
import { PgMessagesService, MessageLevel } from 'src/app/shared/services/pg-messages.service';
import { PgTitleComponent } from '../../../../shared/components/title-bar/title-bar.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { MaterialDateRangeComponent, DateRange } from 'src/app/shared/components/material-date-picker/material-date-range.component';
import { MaterialOrganisationSelectorComponent } from 'src/app/shared/components/material-autocomplete/material-organisationselector.component';
import { MatButtonModule } from '@angular/material/button';
import { forkJoin } from 'rxjs';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MaterialPgInputComponent } from 'src/app/shared/components/material-pg-input/material-pg-input.component';

@Component({
  selector: 'app-lpg-payment-entry',
  templateUrl: 'lpg-payment-entry.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports:[
    SharedModule,
    MaterialDateRangeComponent,
    MaterialOrganisationSelectorComponent,
    MatButtonModule,
    MatCheckboxModule,
    MaterialPgInputComponent
  ],
})
export class LpgPaymentEntryComponent implements OnInit, PgTitleComponent {
  title = new EventEmitter<string>();

  edit: boolean = false;

  payment: Payment = {
    company: '',
    companyId: '',
    payTimestamp: 0,
    paymentBillNo: '',
    source: '',
    sourceOrganisationId: '',
    totalWeight: 0,
    currency: 'ریال',
    costPerKilo: 0,
    wholePayment: 0,
    isDeleted: false
  };
  source: Organisation = Organisation.create();
  sources: Organisation[] = [];
  companies: Organisation[] = [];
  company: Organisation = Organisation.create();
  currencies: string[] = ['دلار', 'ریال', 'درهم'];
  payTimestamp: Date = new Date();
  dateRange: DateRange = {
    startDate: new Date(),
    endDate: new Date()
  };
  success: boolean = false;
  message?: string;

  constructor(private _lpgDistService: LPGDistService,
              private _activatedRoute: ActivatedRoute,
              private _organisationService: OrganisationService,
              private _pgMessagesService: PgMessagesService,
              private _router: Router) { }

  initializePayment(companyId?: string) {
    forkJoin({
      sources: this._organisationService.getSellers(),
      companies: this._organisationService.getDomestics()
    }).subscribe(({ sources, companies }) => {
      this.sources = sources;
      this.companies = companies;
      this.company = this.companies.find(c => c.name === companyId) || Organisation.create();
      if (this.edit) {
        this.source = this.sources.find(x => this.payment?.sourceOrganisationId === x.name) || Organisation.create();
        this.dateRange = {
          startDate: new Date(this.payment?.payTimestamp || 0),
          endDate: momentJ().startOf('day').toDate()
        };
      }
    });
  }

  ngOnInit() {
    this.title.emit('Payment');
    this._activatedRoute.paramMap.subscribe(p => {
      const company = p.get('company');
      this.edit = (company) ? true : false;
      this.dateRange = {
        startDate: momentJ().startOf('day').toDate(),
        endDate: momentJ().startOf('day').toDate()
      };
      if (!company) {
        this.initializePayment();
      } else if (this.edit) {
        const payTimestamp = Number(p.get('payTimestamp'));
        const paymentBillNo = p.get('paymentBillNo')!;
        this._lpgDistService.getOnePaymentRecord(company, payTimestamp, paymentBillNo).subscribe(selectedPayment => {
          this.payment = selectedPayment;
          this.initializePayment(company);
        });
      }

    });
  }

  addPayment() {
    this.payment.company = this.company.nameTranslations['fa'];
    this.payment.companyId = this.company.name;
    this.payment.sourceOrganisationId = this.source.name;
    this.payment.source = this.source.nameTranslations['fa'];
    this.payment.wholePayment = + this.payment.wholePayment;
    this.payment.totalWeight = + this.payment.totalWeight;
    this.payment.costPerKilo = + this.payment.costPerKilo;
    if (!this.edit) {
      this.payment.payTimestamp = this._lpgDistService.correctTimestamp(this.dateRange.startDate);
      this._lpgDistService.addPayment(this.payment).subscribe(() => {
        this.message = 'فیش واریزی به شماره ' + this.payment.paymentBillNo + ' و با مبلغ ' + this.payment.wholePayment + ' ثبت شد';
        this._pgMessagesService.publishMessage({
          message: this.message,
          topic: 'New Payment',
          level: MessageLevel.Info
        });
      }, () => {
        this.message = 'Error';
        this._pgMessagesService.publishMessage({
          message: this.message,
          topic: 'Error',
          level: MessageLevel.Error
        });
      });
    } else {
      this._lpgDistService.updatePayment(this.payment).subscribe(() => {
        this.message = 'فیش واریزی به شماره ' + this.payment.paymentBillNo + ' و با مبلغ ' + this.payment.wholePayment + ' ثبت شد';
        this._pgMessagesService.publishMessage({
          message: this.message,
          topic: 'New Payment',
          level: MessageLevel.Info
        });
        this._router
          .navigateByUrl('/', { skipLocationChange: true })
          .then(() => {
            this._router
              .navigate([
                'lpg-dist/payments',
                this.payment.companyId,
                this.payment.payTimestamp,
                this.payment.paymentBillNo
              ])
              .then((e) => console.log(`Result of Navigation is ${e}`));
          });
      }, () => {
        this.message = 'Error';
        this._pgMessagesService.publishMessage({
          message: this.message,
          topic: 'Error',
          level: MessageLevel.Error
        });
      });
    }
  }

}
